import { create } from 'zustand'

export const useSectionsStore = create((set, get) => ({
  sections: [
    { id: 1, title: 'Generative Art & NFTs', startIndex: 2, endIndex: 4 },
    { id: 2, title: 'Web & 3D Experiences', startIndex: 5, endIndex: 9 },
    { id: 3, title: 'Immersive Installations', startIndex: 10, endIndex: 14 },
    { id: 4, title: 'AI Powered Animations', startIndex: 15, endIndex: 18 },
    { id: 5, title: '', startIndex: 19, endIndex: 20 }
  ],
  
  // Section descriptions for the gallery
  sectionDescriptions: {
    1: "Generative algorithms | Custom shaders | Modular systems | Multichain & interactive works",
    2: "3D world building | Digital events | Multiplayer UX | Spatial audio",
    3: "Real-time visuals | Spatial interaction | Audio Reactive design | Festival & gallery setup",
    4: "Custom model training | Custom workflows | Audio-visual sync | Agentic AI"
  },
  
  // Global audio state
  isGloballyMuted: false,
  
  // Project data for each image/video index - single source of truth
  projectData: {
    0: {
      title: "Glitch Candies Genesis",
      description: "It is the first hand made generative collection of evolving sculptures created using sound synthesis and GLSL shaders minted on Cosmos ecosystem.",
      link: "https://glitchcandies.art/"
    },
    1: {
      title: "Glitch Candies GEN2",
      description: "Complex Glitch Candies, based on generative 3D feedback patches and advanced shaders.",
      link: "https://glitchcandies.art/"
    },
    2: {
      title: "Glitch Candies Genesis",
      description: "Glitch Candies collections embrace the intricacies of code, error and seek beauty in human interaction with blockchain technology.",
      link: "https://glitchcandies.art/"
    },
    3: {
      title: "Glitch Hunter",
      description: "GlitchHunter is custom made Flux dev Lora model trained on Koshi's outputs from MJ and SDXL. Focus is on unusual erratic characters",
      link: "https://civitai.com/models/764243/glitchhunter"
    },
    4: {
      title: "Glitch Hunter SD1.5",
      description: "GlitchHunter SD15 brings Flux's color tone and style to Stable Diffusion 1.5 model, along with GlitchHunter Flux LoRA's erratic character designs. Allowing use in wider range of animation workflows and upscalers",
      link: "https://civitai.com/models/800806/glitchhunter-sd15"
    },
    5: {
      title: "Glitch Candies in the Metaverse",
      description: "Exploring the eye candy glitches as audiovisual generative art and application in interactive experiences.",
      link: "https://medium.com/@glitchcandies/glitch-candies-exploration-of-the-eye-candy-glitches-as-audiovisual-generative-art-2f2c0564eb42"
    },
    6: {
      title: "Tripo3D generator in Three.js",
      description: "We partnered with Tripo3D to test and give feedback on their generator. As a result we have put it in Three.js game environment to test models and generate assets for our projects stright in the browser.",
      link: "https://www.youtube.com/watch?v=rH2D9_7NiXA"
    },
    7: {
      title: "Live Performance on Decentraland Music Festival",
      description: "Audiovisual live performance on Decentraland Music Festival using our GLSL shaders and modular synthesizer systems for 15k visitors we were performing alongside Bjork and other artists.",
    },
    8: {
      title: "Digital and Immersive Events for web3 communities",
      description: "Levriding our NFT collections and aesthetics we create unique installations and experiences for communities from various web3 ecosystems and web2 brands including Playboy, Sandstorm and Secret Network.",
      link: "https://www.youtube.com/watch?v=rH2D9_7NiXA"
    },
    9: {
      title: "Supernatural Creatures Web Teaser",
      description: "Web teaser for Supernatural Creatures gamified experience and collection.",
      link: "https://supernaturalcreatures.xyz/"
    },
    10: {
      title: "Glitch NFT Studio Logo Cube Editor",
      description: "An interactive 3D logo cube editor with customizable patterns and animations built with React Three Fiber.",
      link: "https://github.com/koshimazaki/GLITCH-CUBE-R3F"
    },
    11: {
      title: "VRM Supernatural Creature",
      description: "Our Supernatural Creature VRM model hand sculpted in ZBrush and used in web based experiences and IRL events.",
      link: "https://x.com/glitchcandies/status/1861014281187152032"
    },
    12: {
      title: "Immersive Experience and live performance at NFC Lisbon, 2024",
      description: "Audiovisual live performance on 5 projector screens with generated to spec AI visuals surrounding the audience. Performed at Cult Crypto Art NFC Lisbon opening party.",
      link: "https://x.com/glitchcandies/status/1818038146728431805"
    },
    13: {
      title: "Glitch Candies at Token 2049 in Dubai, 2024",
      description: "Exploration of GLSL shaders in immersive installation surrounding the audience with visuals on ultrawide screen and mirrored surfaces. Invited installaion by Stargaze and Token 2049.",
    
    },
    14: {
      title: "Goddess Sweep/Spectral Shift at Bright Moments, LA, 2023",
      description: "A/V piece selected as a finalist in Deforum competition and presented at Bright Moments, LA. We are using Deforum and Parseq to drive genAI animaton with modular synthesis.",
      link: "https://app.manifold.xyz/c/goddesssweep"
    },
    15: {
      title: "Supernatural Creatures",
      description: "Supernatural Creatures is the genesis 1000 1/1 collection that minted out on Solana via Magic Eden launchpad. It is exploring audio driven generative animations using custom models, exhibited on major galleries and web3 events internationally.",
      link: "https://medium.com/@glitchcandies/supernatural-creatures-fcb993254d04"
    },
    16: {
      title: "Supernatural Arrival",
      description: "Audiovisual genAI animation that was minted 10872 times as an open edition and was showcased on Miami Art Week 2023.",
      link: "https://magiceden.io/launchpad/supernatural_arrival"
    },
    17: {
      title: "Unlock Your City, Vuse Global",
      description: "Animation produced for Vuse Global for the Unlock Your City, collaboration with PS Labs and Wunthompson Agency. Showcased during Ben Klocks live set in London as part of the Vuse campaign.",
      link: "https://www.instagram.com/p/Cx7wxh7t6X5/"
    },
    18: {
      title: "AI Partnership with Freepik",
      description: "As Freep!k AI partner we provide consultancy and development of UX, AI models testing and development for their platform.",
      link: "https://x.com/glitchcandies/status/1853474767971467566"
    },
    19: {
      title: "Open Source Contributions",
      description: "As part of open source community we contribute on github, huggingface, civitai with models and scripts and tools developed for our projects.",
      link: "https://github.com/koshimazaki/AI-Utils"
    }
  },
  
  activeSection: 1,
  currentIndex: 0,
  progress: 0, // Vertical scroll progress
  horizontalProgress: 0, // Horizontal scroll progress
  lastHorizontalProgress: 0, // Track previous progress for direction detection
  scrollDirection: 'forward', // 'forward' or 'backward'
  shouldNavigateToStudio: false, // Flag to trigger Studio navigation
  shouldNavigateToStart: false, // Flag to trigger return to start
  isTransitioningToSplash: false, // Flag to prevent infinite splash transitions
  showSectionTitles: true, // Flag to control section titles visibility
  titlesHiddenByButton: false, // Flag to track if titles were hidden by button press
  isInStudio: false, // Flag to track if we're in Studio section
  studioWasViewed: false, // Flag to track if Studio was ever viewed/triggered
  videoIsScalingUp: false, // Flag to track if video is currently scaling up

  setActiveSection: (id) => {
    const current = get().activeSection;
    if (current !== id) {
      console.log(`Changing section from ${current} to ${id}`);
      set({ activeSection: id });
    }
  },

  setCurrentIndex: (index) => {
    set({ currentIndex: index });
  },

  setProgress: (progress) => {
    set({ progress });
  },

  setHorizontalProgress: (progress) => {
    const { lastHorizontalProgress, scrollDirection } = get();
    const newDirection = progress > lastHorizontalProgress ? 'forward' : 'backward';
    
    // Log direction changes for debugging
    if (newDirection !== scrollDirection) {
      console.log(`Scroll direction changed: ${scrollDirection} -> ${newDirection}, progress: ${progress.toFixed(3)}`);
    }
    
    set({ 
      horizontalProgress: progress,
      lastHorizontalProgress: progress,
      scrollDirection: newDirection
    });
  },

  // Function to navigate to Studio section or back to start (toggle behavior)
  navigateToStudio: () => {
    const { horizontalProgress, isInStudio } = get();
    
    console.log('navigateToStudio called - horizontalProgress:', horizontalProgress, 'isInStudio:', isInStudio);
    
    // If we're already in Studio section (>= 90%), go back to the very beginning (index 0)
    if (horizontalProgress >= 0.9 || isInStudio) {
      console.log('Navigating back to very beginning (index 0) - showing section titles');
      set({ 
        shouldNavigateToStart: true,
        titlesHiddenByButton: false, // Reset when going back
        showSectionTitles: true // Show titles when going back
      });
    } else {
      // Hide section titles immediately when button is pressed AND mark Studio as viewed
      console.log('Navigating to studio - hiding section titles');
      set({ 
        shouldNavigateToStudio: true,
        showSectionTitles: false,
        titlesHiddenByButton: true,
        studioWasViewed: true // Mark Studio as viewed when button is clicked
      });
    }
  },

  // Reset navigation flags
  resetStudioNavigation: () => {
    set({ shouldNavigateToStudio: false });
  },

  resetStartNavigation: () => {
    set({ shouldNavigateToStart: false });
  },

  // Set splash transition flag
  setTransitioningToSplash: (isTransitioning) => {
    set({ isTransitioningToSplash: isTransitioning });
  },

  // Toggle section titles visibility
  toggleSectionTitles: () => {
    set(state => ({ showSectionTitles: !state.showSectionTitles }));
  },

  // Hide section titles
  hideSectionTitles: () => {
    set({ showSectionTitles: false });
  },

  // Show section titles
  showSectionTitlesFunc: () => {
    set({ showSectionTitles: true });
  },

  // Handle Studio section entry with delayed title reveal
  enterStudioSection: () => {
    const { titlesHiddenByButton } = get();
    set({ 
      isInStudio: true,
      studioWasViewed: true // Mark that Studio was viewed
    });
    
    // Don't automatically show titles if they were hidden by button
    // The user explicitly chose to hide them by clicking "BUILD WITH US"
    // They can be shown again by other means (like scrolling back or clicking the button again)
  },

  // Handle leaving Studio section
  leaveStudioSection: () => {
    set({ 
      isInStudio: false,
      titlesHiddenByButton: false,
      showSectionTitles: true
    });
  },

  // Get video visibility threshold based on scroll direction
  getVideoVisibilityThreshold: () => {
    const { scrollDirection, horizontalProgress } = get();
    
    let shouldShow;
    if (scrollDirection === 'forward') {
      // Forward: Hide video when reaching middle of section 1 (index 3, progress ~0.15)
      // Let video stay a bit longer into the first section
      shouldShow = horizontalProgress <= 0.15;
    } else {
      // Backward: Show video only when very close to the beginning (index 1, progress 0.08)
      // Much more restrictive to prevent showing too soon when scrolling back
      shouldShow = horizontalProgress <= 0.08;
    }
    
    return shouldShow;
  },

  // Get current slide information
  getCurrentSlideInfo: () => {
    const { currentIndex, sections } = get();
    
    // Find which section this slide belongs to
    const currentSection = sections.find(section => 
      currentIndex >= section.startIndex && currentIndex <= section.endIndex
    );
    
    // Determine slide area
    const firstSection = sections.find(s => s.id === 1);
    const firstSectionStartIndex = firstSection ? firstSection.startIndex : 2;
    
    const slideInfo = {
      index: currentIndex,
      isPreSection: currentIndex < firstSectionStartIndex,
      isInSection: !!currentSection,
      currentSection: currentSection || null,
      sectionId: currentSection ? currentSection.id : null,
      sectionTitle: currentSection ? currentSection.title : null
    };
    
    return slideInfo;
  },

  // Check if we should transition back to splash screen
  shouldTransitionToSplash: () => {
    const { scrollDirection, horizontalProgress, isTransitioningToSplash, getCurrentSlideInfo } = get();
    
    // Don't trigger if we're already transitioning
    if (isTransitioningToSplash) return false;
    
    if (scrollDirection === 'backward') {
      const slideInfo = getCurrentSlideInfo();
      
      // Only trigger splash when:
      // 1. We're in the pre-section area (slides 0-1)
      // 2. We're at the very beginning with low progress
      const isAtVeryBeginning = slideInfo.index <= 1 && horizontalProgress <= 0.05;
      
      // console.log(`Splash check:`, {
      //   slideIndex: slideInfo.index,
      //   isPreSection: slideInfo.isPreSection,
      //   horizontalProgress: horizontalProgress.toFixed(3),
      //   isAtVeryBeginning,
      //   currentSection: slideInfo.sectionTitle || 'None'
      // });
      
      // Must be both in pre-section area AND at very beginning
      return slideInfo.isPreSection && isAtVeryBeginning;
    }
    
    return false;
  },

  getSectionForIndex: (index) => {
    const { sections } = get();
    return sections.find(section => 
      index >= section.startIndex && index <= section.endIndex
    );
  },

  getSectionOpacity: (sectionId, progress) => {
    const { sections, currentIndex } = get();
    const section = sections.find(s => s.id === sectionId);
    
    if (!section || currentIndex < section.startIndex) return 0;
    
    const totalItems = 20;
    const sectionStart = section.startIndex / totalItems;
    const sectionEnd = (section.endIndex + 1) / totalItems;
    
    if (progress >= sectionStart && progress <= sectionEnd) {
      const sectionWidth = sectionEnd - sectionStart;
      const fadeZone = sectionWidth * 0.15;
      
      if (progress < sectionStart + fadeZone) {
        return (progress - sectionStart) / fadeZone;
      } else if (progress > sectionEnd - fadeZone) {
        return 1 - (progress - (sectionEnd - fadeZone)) / fadeZone;
      }
      return 1;
    }
    return 0;
  },

  getOpacityForSection: (sectionId, scrollPosition, clicked) => {
    if (clicked !== null) return 0;
    
    const { sections, currentIndex } = get();
    const section = sections.find(s => s.id === sectionId);
    
    if (!section || currentIndex < section.startIndex) return 0;
    
    const totalItems = 20;
    const sectionStart = section.startIndex / totalItems;
    const sectionEnd = (section.endIndex + 1) / totalItems;
    
    if (scrollPosition >= sectionStart && scrollPosition <= sectionEnd) {
      const sectionWidth = sectionEnd - sectionStart;
      const fadeZone = sectionWidth * 0.15;
      
      if (scrollPosition < sectionStart + fadeZone) {
        return (scrollPosition - sectionStart) / fadeZone;
      } else if (scrollPosition > sectionEnd - fadeZone) {
        return 1 - (scrollPosition - (sectionEnd - fadeZone)) / fadeZone;
      }
      return 1;
    }
    return 0;
  },

  // Get human-readable slide position description
  getSlideDescription: () => {
    const slideInfo = get().getCurrentSlideInfo();
    
    if (slideInfo.isPreSection) {
      return `Pre-section slide ${slideInfo.index} (before any sections)`;
    } else if (slideInfo.isInSection) {
      return `Section ${slideInfo.sectionId}: "${slideInfo.sectionTitle}" - slide ${slideInfo.index}`;
    } else {
      return `Post-section slide ${slideInfo.index}`;
    }
  },

  // Set video scaling state
  setVideoScalingUp: (isScaling) => {
    set({ videoIsScalingUp: isScaling });
  },

  // Check if titles should be hidden (Studio was viewed AND video is scaling up)
  shouldHideTitlesDuringTransition: () => {
    const { studioWasViewed, videoIsScalingUp } = get();
    const shouldHide = studioWasViewed && videoIsScalingUp;
    
    if (shouldHide) {
      // console.log('Hiding titles: Studio was viewed and video is scaling up');
    }
    
    return shouldHide;
  },

  // Reset Studio viewed flag (when user goes back to beginning)
  resetStudioViewed: () => {
    set({ studioWasViewed: false });
  },

  // Reset all states to initial values (for page refresh)
  resetToInitialState: () => {
    set({
      activeSection: null,
      currentIndex: 0,
      horizontalProgress: 0,
      progress: 0,
      showSectionTitles: true,
      isInStudio: false,
      shouldNavigateToStudio: false,
      shouldNavigateToStart: false,
      isTransitioningToSplash: false,
      titlesHiddenByButton: false,
      studioWasViewed: false,
      scrollDirection: 'forward'
    });
  },

  // Global audio control
  setGlobalMute: (muted) => {
    set({ isGloballyMuted: muted });
  },
  
  toggleGlobalMute: () => {
    const { isGloballyMuted } = get();
    set({ isGloballyMuted: !isGloballyMuted });
  }
}))